import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import UnitsViewer from './attrs/UnitsViewer';
import MeasurementViewer from './attrs/MeasurementViewer';
import TagsViewer from './attrs/TagsViewer';
import LabelsManager from './attrs/LabelsManager';

const PointType = ({ base, ptName, id, tags, labels, measurementId, defaultUnitId }) => (
  <div className="leaf point-type">
    <Typography variant="h5" className="name">
      {ptName}
    </Typography>
    <UnitsViewer defaultId={defaultUnitId} measurementId={measurementId} />
    <MeasurementViewer base={base} measurementId={measurementId} />
    <TagsViewer tags={tags} />
    <LabelsManager labels={labels} pointId={id} />
  </div>
);

export default connect(
  (
    {
      entities: {
        pointTypes: { byId, idByName },
      },
    },
    { ptName }
  ) => {
    const id = idByName[ptName];
    const pt = byId[id];
    const tags = pt?.tags || [];
    tags.sort();
    const labels = pt?.labels || [];
    labels.sort();
    return {
      tags,
      ptName,
      id,
      labels,
      measurementId: pt?.measurementId,
      defaultUnitId: pt?.defaultUnitId,
    };
  }
)(PointType);
